import React, { useContext } from "react";
import { css } from "emotion";
import GenericCard from "../GenericCard";
import { colors, textSizes } from "../../styles/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GlobalContext } from "../../context/GlobalState";
import { BillingContext } from "../../context/BillingState";
import workspaces from "../../services/api/workspaces";

const CreditCardBar = ({ paymentObj, isEditing, isDefault }) => {
  const { card } = paymentObj;
  const { currentWorkspace } = useContext(GlobalContext);
  const { getCardsFlag, toggleGetCards } = useContext(BillingContext);
  const handleClick = async () => {
    if (isDefault) {
      return;
    }
    const updateData = {
      workspace: currentWorkspace.id,
      cardId: paymentObj.id,
    };
    try {
      // do update default payment method call here
      const { data } = await workspaces.updateBillingcard(updateData);
      // console.log(data);
      toggleGetCards(!getCardsFlag);
    } catch (error) {
      console.log(error);
    }
  };

  const removeCard = async () => {
    const removeData = {
      workspace: currentWorkspace.id,
      cardId: paymentObj.id,
    };

    try {
      const { data } = await workspaces.removePaymentMethod(removeData);
      // console.log(data);

      toggleGetCards(!getCardsFlag);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={container + ` ${isEditing ? editing : ""}`}>
      <GenericCard style="credit-card-bar" onClick={handleClick}>
        <input type="radio" checked={isDefault} readOnly />
        <div className="cardInfo">
          <p className="brand-name">{card.brand}</p>
          <p className="maskedNumbers">....</p>
          <p>{card.last4}</p>
        </div>
        <p>
          {card.exp_month}/{card.exp_year.toString().slice(2)}
        </p>
      </GenericCard>
      {!isDefault && (
        <FontAwesomeIcon
          onClick={removeCard}
          className="remove-btn"
          icon="times"
        />
      )}
    </div>
  );
};

export default CreditCardBar;

const container = css`
  position: relative;
  width: 100%;

  .remove-btn {
    position: absolute;
    right: 10px;
    top: 30px;
    color: ${colors.cancel};
    cursor: pointer;
  }

  .credit-card-bar {
    width: 100%;
    border-radius: 40px;
    margin: 10px 0;
    justify-content: space-between;
    align-items: center;
    padding: 18px;
    cursor: pointer;
    user-select: none;
    transition-duration: 300ms;
    position: relative;
    z-index: 40;

    input {
      margin-right: 15px;
      cursor: pointer;
      position: relative;

      &::after {
        content: "";
        display: block;
        position: absolute;
        left: -4px;
        top: -4px;
        background-color: white;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        border: 1px solid #dfdfdf;
      }

      &:checked {
        &::after {
          background-color: ${colors.accentColor};
          box-shadow: inset 0 0 0 3px white;
          border-color: ${colors.accentColor};
        }
      }
    }

    p {
      color: ${colors.titleColor};
      font-size: ${textSizes.intermediate};
    }

    .dotBorder {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 1px solid ${colors.subtitleColor};
      display: flex;
      justify-content: center;
      align-items: center;
      transition-duration: 200ms;

      .dot {
        width: 14px;
        height: 14px;
        background-color: ${colors.accentColor};
        border-radius: 50%;
      }
    }

    .active {
      border-color: ${colors.accentColor};
    }

    .cardInfo {
      flex: 1;
      display: flex;
      align-items: center;
      padding-left: 30px;

      .brand-name {
        text-transform: capitalize;
      }

      .maskedNumbers {
        font-size: 32px;
        font-weight: bold;
        padding: 0 12px 16px;
        line-height: 5px;
      }
    }
  }
`;

const editing = css`
  .credit-card-bar {
    width: 90%;
  }
`;
